import React from "react";
import * as UI from "./ui.jsx";
// Live — parade-area streams. During parade hours (07:00–09:00, 17:00–19:00)
// a still frame stands in for the stream; outside them, the parade schedule.

const { useState: useStateL, useEffect: useEffectL } = React;

function LiveView() {
  const { Card, Tag, ModuleGate, MockNote } = UI;
  const { PARADE_AREAS, PARADE_SCHEDULE, PARADE_STILL, paradeSessionAt } = window.DATA;
  const vendorArea = PARADE_AREAS.length ? PARADE_AREAS[PARADE_AREAS.length - 1].id : null;
  const [areaId, setAreaId] = useStateL(vendorArea);
  const [session, setSession] = useStateL(() => paradeSessionAt(window.DATA.now()));
  useEffectL(() => {
    const id = setInterval(() => setSession(paradeSessionAt(window.DATA.now())), 15000);
    return () => clearInterval(id);
  }, []);
  const area = PARADE_AREAS.find(a => a.id === areaId);

  return (
    <ModuleGate modules="live.parade">
      <div className="fade-in">
        {/* Camera switcher — one per lane, mobile-friendly */}
        <div className="lane-switch">
          {PARADE_AREAS.map(a => (
            <button key={a.id} className={a.id === areaId ? "on" : ""} onClick={() => setAreaId(a.id)}>
              <span className="display" style={{ fontSize: 20 }}>{a.id}</span>
              <span>{a.id === vendorArea ? "Your barn" : "Parade"}</span>
            </button>
          ))}
        </div>

        {session && area ? (
          <Card style={{ marginTop: 18, padding: 0, overflow: "hidden" }} className="flush">
            <div className="player">
              {PARADE_STILL && <img src={PARADE_STILL} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", display: "block" }}/>}
              <div className="player-hud">
                <div className="row" style={{ justifyContent: "space-between" }}>
                  <span>{area.name} · {area.cam}</span>
                  <span>{session.name} · until {session.ends}</span>
                </div>
              </div>
            </div>
            <div className="row" style={{ padding: "14px 20px", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
              <div>
                <div style={{ fontFamily: "var(--font-display)", fontSize: 20 }}>{area.name}</div>
                <div className="muted" style={{ fontSize: 12, marginTop: 2 }}>{session.name} in progress · streams end {session.ends}</div>
              </div>
              <div className="row" style={{ gap: 8 }}>
                <MockNote module="live.parade"/>
                {area.id === vendorArea && <Tag variant="gold">Your lane · {window.DATA.VENDOR.barn}</Tag>}
              </div>
            </div>
          </Card>
        ) : (
          <Card title="Parades aren't streaming right now" subtitle="Streams run during parade hours — 07:00–09:00 and 17:00–19:00." style={{ marginTop: 18 }}>
            <div className="muted" style={{ fontSize: 14 }}>The schedule below shows the next sessions.</div>
          </Card>
        )}

        {/* Schedule below the player */}
        <div className="section-head" style={{ marginTop: 26 }}>
          <h2>Parade schedule</h2>
        </div>
        <div className="grid cols-2">
          {PARADE_SCHEDULE.map(d => (
            <Card key={d.day} title={d.day}>
              {d.sessions.map(([time, name], i) => (
                <div key={i} className="row" style={{ justifyContent: "space-between", padding: "12px 0", borderTop: i ? "1px solid var(--divider)" : "0" }}>
                  <div className="row" style={{ gap: 14 }}>
                    <span className="display" style={{ fontSize: 20, color: "var(--inglis-blue)" }}>{time}</span>
                    <span style={{ fontSize: 14.5 }}>{name}</span>
                  </div>
                  {session && d.day.startsWith("Today") && name === session.name && <Tag variant="live">Now</Tag>}
                </div>
              ))}
            </Card>
          ))}
        </div>
      </div>
    </ModuleGate>
  );
}

export { LiveView };
